import { Backstory } from "@backstory/browser";
import { API_URL, ingestUrl } from "../api";

/**
 * Records the dashboard itself when the deployment sets a browser key. Calls to
 * the API carry the session so its requests and logs group under the replay.
 * Customer replays shown in the player are blocked, never re-recorded.
 */
export function startRecorder(): void {
  const key = typeof window !== "undefined" ? window.__BACKSTORY_CONFIG__?.recorderKey : undefined;
  if (!key) return;
  let apiOrigin = "";
  try {
    apiOrigin = new URL(API_URL).origin;
  } catch {
    apiOrigin = "";
  }
  Backstory.init({
    projectKey: key,
    ingestUrl: ingestUrl(),
    privacy: { mode: "strict", blockSelector: ".player-stage, [data-backstory-block]" },
    otel: { propagateTraceContext: apiOrigin ? [apiOrigin] : [] },
  });
}
